import { Button, withStyles } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";

const WithCustomCSS = withStyles((theme) => ({
    root: {
        "&:hover": {
            backgroundColor: `${blue[900]} !important`,
        },
    },
}))(Button);

const CustomButton = ({ children, onClick, ...rest }) => {
    return (
        <WithCustomCSS onClick={onClick} {...rest}>
            {children}
        </WithCustomCSS>
    );
};

export default CustomButton;
